import React, { useState } from 'react';
import useGameStore, { getOffice, getAvailablePromotions, POLITICAL_OFFICES } from '../../game/gameStore';

export default function ElectionOverlay() {
  const [step, setStep] = useState('summary');
  const [selectedOffice, setSelectedOffice] = useState(null);

  const player = useGameStore(s => s.player);
  const currentOffice = useGameStore(s => s.currentOffice);
  const careerPath = useGameStore(s => s.careerPath);
  const territories = useGameStore(s => s.territories);
  const playerParty = useGameStore(s => s.playerParty);
  const coalitionParties = useGameStore(s => s.coalitionParties);
  const playerVereadorId = useGameStore(s => s.playerVereadorId);
  const electionResult = useGameStore(s => s.electionResult);
  const runForElection = useGameStore(s => s.runForElection);
  const handleElectionResult = useGameStore(s => s.handleElectionResult);
  const stayInOffice = useGameStore(s => s.stayInOffice);

  const office = getOffice(currentOffice);
  const controllerId = playerVereadorId || playerParty;
  const result = getAvailablePromotions(player, currentOffice, territories, controllerId, coalitionParties);

  const totalT = Object.keys(territories).length;
  const controlledT = Object.values(territories).filter(t => t.controlledBy === controllerId).length;
  const controlPct = totalT > 0 ? Math.round((controlledT / totalT) * 100) : 0;

  const pathStr = careerPath.map(id => { const o = getOffice(id); return `${o.emoji} ${o.name}`; }).join(' → ');

  if (step === 'summary') {
    return (
      <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{ background: 'rgba(2,8,16,0.85)' }}>
        <div className="w-full sm:max-w-xl rounded-t-2xl sm:rounded-2xl overflow-hidden max-h-[95vh] sm:max-h-[90vh] flex flex-col" style={{ background: '#0b1424', border: '1px solid #182440' }}>
          <div className="h-1 w-full bg-green-400 shrink-0" />
          <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1" style={{ scrollbarWidth: 'thin' }}>
            <h2 className="text-lg sm:text-xl font-bold text-green-400 text-center">MANDATO ENCERRADO</h2>
            <p className="text-xs sm:text-sm text-center" style={{ color: '#8899bb' }}>
              Você completou seu mandato como {office.name}
            </p>

            <div className="text-center text-xs sm:text-sm font-bold" style={{ color: '#aabbcc' }}>
              <span className="text-green-400">Carisma {player.popularity}%</span> · <span className="text-purple-400">Influência {player.influence}%</span> · <span className="text-amber-400">R${player.money}K</span>
            </div>
            <div className={`text-center text-xs font-bold ${player.risk >= 60 ? 'text-red-400' : 'text-red-400/60'}`}>
              {player.risk >= 80 ? '⚠ ' : ''}Risco: {player.risk}%{player.risk >= 80 ? ' — FICHA LIMPA EM RISCO!' : player.risk >= 60 ? ' — Cuidado!' : ''}
            </div>

            <p className="text-[10px] text-center" style={{ color: '#556688' }}>{pathStr}</p>

            {controlPct > 0 && (
              <div className="text-center">
                <p className="text-xs font-bold mb-1" style={{ color: controlPct > 50 ? '#4ade80' : '#fbbf24' }}>
                  Controle territorial: {controlPct}%
                </p>
                <div className="h-1.5 rounded-full mx-auto max-w-xs" style={{ background: '#141e30' }}>
                  <div className="h-full rounded-full" style={{ width: `${controlPct}%`, background: controlPct > 50 ? '#4ade80' : '#fbbf24' }} />
                </div>
              </div>
            )}

            <div className="flex justify-center pt-2">
              <button onClick={() => setStep('offices')}
                className="px-6 py-2.5 rounded-lg text-sm font-bold text-white"
                style={{ background: '#14532d', border: '1px solid #2a8040' }}>
                Ver opções de candidatura
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (step === 'offices') {
    const nextOffices = POLITICAL_OFFICES.filter(o => o.tier > office.tier && o.tier <= office.tier + 2 && o.req);
    return (
      <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{ background: 'rgba(2,8,16,0.85)' }}>
        <div className="w-full sm:max-w-xl rounded-t-2xl sm:rounded-2xl overflow-hidden max-h-[95vh] sm:max-h-[90vh] flex flex-col" style={{ background: '#0b1424', border: '1px solid #182440' }}>
          <div className="h-1 w-full shrink-0" style={{ background: '#d4a574' }} />
          <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1" style={{ scrollbarWidth: 'thin' }}>

            {result.fichaLimpaBlocked ? (
              <>
                <h2 className="text-lg font-bold text-red-400 text-center">LEI DA FICHA LIMPA</h2>
                <p className="text-sm text-center text-red-300">{result.reason}</p>
                <p className="text-sm text-center font-bold text-red-400">Risco atual: {player.risk}%</p>
              </>
            ) : result.promotions.length === 0 ? (
              <>
                <h2 className="text-lg font-bold text-amber-400 text-center">SEM OPÇÕES DE CANDIDATURA</h2>
                <p className="text-sm text-center" style={{ color: '#8899bb' }}>
                  Você não atingiu os requisitos para nenhum cargo superior.
                </p>
                <div className="space-y-2">
                  {nextOffices.map(nxt => {
                    const meetPop = player.popularity >= nxt.req.popularity;
                    const meetInf = player.influence >= nxt.req.influence;
                    const meetMon = player.money >= nxt.req.money;
                    return (
                      <div key={nxt.id} className="text-[11px] text-center" style={{ color: '#556688' }}>
                        {nxt.emoji} {nxt.name}: {meetPop ? '✅' : '❌'} Pop ≥{nxt.req.popularity}% {meetInf ? '✅' : '❌'} Infl ≥{nxt.req.influence}% {meetMon ? '✅' : '❌'} R$≥{nxt.req.money}K
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                <h3 className="text-xs font-bold text-center tracking-widest" style={{ color: '#d4a574' }}>CANDIDATAR-SE A:</h3>
                <div className="space-y-3">
                  {result.promotions.map(promo => {
                    const cost = { money: Math.round((promo.req?.money || 50) * 0.3), risk: 5 + promo.tier * 3 };
                    return (
                      <button key={promo.id} onClick={() => { setSelectedOffice(promo.id); setStep('campaign'); }}
                        className="w-full text-left p-4 rounded-xl transition-all hover:scale-[1.01]"
                        style={{ background: '#101c32', border: '1px solid #1a2d50' }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor = '#d4a574'; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor = '#1a2d50'; }}>
                        <div className="flex items-start justify-between">
                          <div>
                            <p className="text-base font-bold" style={{ color: '#d4a574' }}>{promo.emoji} {promo.name}</p>
                            <p className="text-[10px] mt-0.5" style={{ color: '#556688' }}>{promo.esfera} · {promo.poder} · {promo.sistema === 'proporcional' ? 'Proporcional' : 'Majoritário'}</p>
                            <p className="text-xs mt-1" style={{ color: '#7788aa' }}>{promo.desc}</p>
                          </div>
                          <div className="text-right shrink-0 ml-4">
                            <p className="text-xs font-bold text-amber-400">R${promo.salary}K/mês</p>
                            <p className="text-[10px] mt-1" style={{ color: '#556688' }}>{promo.turns} turnos</p>
                            <p className="text-[10px] text-amber-400/80 mt-1">Custo: R${cost.money}K</p>
                            <p className="text-[10px] text-red-400 mt-0.5">⚠ +{cost.risk}% risco</p>
                          </div>
                        </div>
                      </button>
                    );
                  })}
                </div>
              </>
            )}

            <div className="flex justify-center pt-2">
              <button onClick={() => stayInOffice()}
                className="px-5 py-2 rounded-lg text-xs font-bold"
                style={{ background: '#1a1a30', color: '#6688aa', border: '1px solid #2a2a50' }}>
                CONTINUAR COMO {office.name.toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (step === 'campaign') {
    const promo = getOffice(selectedOffice);
    const cost = { money: Math.round((promo.req?.money || 50) * 0.3), risk: 5 + promo.tier * 3 };
    return (
      <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{ background: 'rgba(2,8,16,0.85)' }}>
        <div className="w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl overflow-hidden max-h-[95vh] sm:max-h-[90vh] flex flex-col" style={{ background: '#0b1424', border: '1px solid #182440' }}>
          <div className="h-1 w-full shrink-0" style={{ background: '#d4a574' }} />
          <div className="p-4 sm:p-6 space-y-4 text-center overflow-y-auto flex-1" style={{ scrollbarWidth: 'thin' }}>
            <h2 className="text-lg font-bold" style={{ color: '#d4a574' }}>{promo.emoji} Campanha para {promo.name}</h2>
            <p className="text-sm" style={{ color: '#8899bb' }}>
              Investir na campanha custará <span className="text-amber-400 font-bold">R${cost.money}K</span>.
            </p>
            <div className="p-2 rounded-lg" style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.15)' }}>
              <p className="text-xs text-red-400 font-bold">⚠ Risco aumenta em +{cost.risk}%</p>
              <p className="text-[10px] text-red-400/60">
                Atual: {player.risk}% → Após: {Math.min(100, player.risk + cost.risk)}%
                {player.risk + cost.risk >= 80 ? ' — FICHA LIMPA AMEAÇADA!' : ''}
              </p>
            </div>
            <div className="flex gap-3 justify-center pt-2">
              <button onClick={() => setStep('offices')}
                className="px-4 py-2 rounded-lg text-xs font-bold"
                style={{ background: '#1a1a30', color: '#6688aa', border: '1px solid #2a2a50' }}>
                Voltar
              </button>
              <button onClick={() => { runForElection(selectedOffice); setStep('result'); }}
                className="px-6 py-2 rounded-lg text-sm font-bold"
                style={{ background: '#14532d', color: '#4ade80', border: '1px solid #2a8040' }}>
                Lançar Candidatura
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (step === 'result' && electionResult) {
    const promo = getOffice(selectedOffice);
    const elected = electionResult.elected;
    return (
      <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" style={{ background: elected ? 'rgba(2,16,8,0.85)' : 'rgba(32,8,8,0.85)' }}>
        <div className="w-full sm:max-w-lg rounded-t-2xl sm:rounded-2xl overflow-hidden max-h-[95vh] sm:max-h-[90vh] flex flex-col" style={{ background: '#0b1424', border: `1px solid ${elected ? '#1a4830' : '#481a1a'}` }}>
          <div className="h-1 w-full shrink-0" style={{ background: elected ? '#4ade80' : '#f87171' }} />
          <div className="p-4 sm:p-6 space-y-4 text-center overflow-y-auto flex-1" style={{ scrollbarWidth: 'thin' }}>
            <h2 className="text-2xl font-bold" style={{ color: elected ? '#4ade80' : '#f87171' }}>
              {elected ? 'ELEITO!' : 'DERROTA NAS URNAS'}
            </h2>
            <p className="text-sm" style={{ color: '#8899bb' }}>
              {promo.emoji} {promo.name} — {electionResult.type === 'proporcional' ? 'Eleição Proporcional' : 'Eleição Majoritária'}
            </p>
            <p className="text-xs" style={{ color: '#556688' }}>
              {electionResult.totalEleitores.toLocaleString('pt-BR')} eleitores
            </p>

            {electionResult.type === 'proporcional' ? (
              <div className="space-y-1 text-xs" style={{ color: '#7788aa' }}>
                <p>Votos do partido: {electionResult.playerPartyVotes.toLocaleString('pt-BR')}</p>
                <p>Vagas: {electionResult.playerSeats} de {electionResult.vagas}</p>
                <p className="font-bold" style={{ color: elected ? '#4ade80' : '#f87171' }}>
                  Seus votos: {electionResult.playerVotes.toLocaleString('pt-BR')} ({electionResult.playerRank}º no partido)
                </p>
              </div>
            ) : (
              <div className="space-y-1 text-xs" style={{ color: '#7788aa' }}>
                <p className="font-bold" style={{ color: elected ? '#4ade80' : '#f87171' }}>
                  Seus votos: {(electionResult.playerPct * 100).toFixed(1)}%
                </p>
                {electionResult.opponents?.[0] && (
                  <p>{electionResult.opponents[0].name}: {(electionResult.opponents[0].pct * 100).toFixed(1)}%</p>
                )}
                {electionResult.secondRound && (
                  <p className="font-bold" style={{ color: '#d4a574' }}>
                    2º Turno: {(electionResult.secondRound.playerPct * 100).toFixed(1)}% vs {(electionResult.secondRound.opponentPct * 100).toFixed(1)}%
                  </p>
                )}
              </div>
            )}

            <p className="text-xs" style={{ color: '#8899bb' }}>{electionResult.details}</p>

            {!elected && (
              <div className="p-3 rounded-lg" style={{ background: 'rgba(74,222,128,0.05)', border: '1px solid rgba(74,222,128,0.1)' }}>
                <p className="text-xs text-green-400 font-bold">Ganhou visibilidade: +5 Carisma, +3 Influência</p>
              </div>
            )}

            <button onClick={() => handleElectionResult(elected, selectedOffice)}
              className="px-6 py-2.5 rounded-lg text-sm font-bold"
              style={{ background: elected ? '#14532d' : '#1a1a30', color: elected ? '#4ade80' : '#6688aa', border: `1px solid ${elected ? '#2a8040' : '#2a2a50'}` }}>
              {elected ? `ASSUMIR CARGO DE ${promo.name.toUpperCase()}` : `CONTINUAR COMO ${office.name.toUpperCase()}`}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
